import { useMutation, useQueryClient } from 'react-query'

import { accountsService } from 'src/services/accounts.service'

import { QUERY_KEYS } from 'src/constants'
import { IAccountCreateFormDto } from 'src/types'
import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'

const useAddAccount = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ image, media, ...account }: IAccountCreateFormDto) => {
      const uploadedIcon = await mediaEntityUploadService.uploadIcon(image.file, image.icon)
      const uploadedMedia = await mediaEntityUploadService.uploadMedia(media)

      return await accountsService.createAccount({
        ...account,
        media: uploadedMedia,
        image: uploadedIcon ? uploadedIcon[0] : image.icon || null,
        image_small: uploadedIcon ? uploadedIcon[1] : account.image_small,
        image_medium: uploadedIcon ? uploadedIcon[2] : account.image_medium,
      })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.ACCOUNTS)
      },
    },
  )
}

export { useAddAccount }
